<template>
    <div>
        <template v-for="valor,i in form">
            <accordion      
                :id="`valores_debitados_accordion_${i}`" 
                :title="`Valor ${i+1}`"
                class="col-12 mt-3" 
                accordion="valores_debitados"  
                :key="i"          
            >
                <template #append-title>
                    <b-button variant="flat-danger" class="ml-2" size="sm" @click="removerValor(valor)">
                        <i class="fa-solid fa-trash mr-2"></i>
                        Remover valor
                    </b-button>
                </template>
                <div class="p-3">
                    <div class="row">
                        <input-select class="col-12 col-md-8" label="Projeto" v-model="valor.projetoObj" :options="options.projetos" ref="projeto" required/>
                        <input-money class="col-12 col-md-4" label="Valor" v-model="valor.valor" ref="valorDebitado" required/>
                        <input-textarea class="col-12" label="Informação adicional" v-model="valor.informacaoAdicional" ref="informacao"/>            
                    </div>
                </div>
            </accordion>
        </template>
        <div class="row mt-3">
            <div class="col-12">
                <b-button variant="info" size="sm" @click="adicionarValor">
                    <i class="fa-solid fa-plus-circle mr-2"></i>
                    Adicionar valor
                </b-button>
            </div>
        </div>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputMoney from "@/components/inputs/InputMoney";
import helpers from "@/common/utils/helpers";
import {FormMixin} from "@/common/mixins/FormMixin";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import InputTextarea from '@/components/inputs/InputTextarea.vue';
import Accordion from '@/components/card/Accordion';

import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
export default {
    mixins: [FormMixin, AlertasMixin],
    components : {
        InputSelect,
        InputMoney,
        InputTextarea,
        Accordion
    },
    props : {
        form : {
            required : true,
        },
        idAnexo : {
            required : true,
        },
    },
    data : () => ({
        options : {
            meses : helpers.retornarMeses(),
            projetos : []
        }
    }),
    mounted(){
        this.buscarProjetos();
    },
    methods : {
        buscarProjetos : function(){
            MovimentacaoFinanceiraService.listarProjetos(this.idAnexo).then(res => {
                this.options.projetos = res.data.data.map(el => {
                    return {
                        value : el.projetoGestaoId ||
                            el.projetoId,
                        text : (el.projetoGestao ? el.projetoGestao.codigo : 
                                    el.projeto ? el.projeto.codigo : 'Sem código'    
                                ) ,
                        el : el
                    }
                })
            })
        },
        adicionarValor : function(){
            this.form.push({
                valor : 0,
                projetoObj : '',
                informacaoAdicional : ''
            });
        },
        removerValor : function(valor){
            if(!valor.id){
                this.form.splice(this.form.indexOf(valor), 1);
                return;
            }

            this.confirmar("Deseja realmente remover este valor?").then(confirmado => {
                if(!confirmado) return;

                MovimentacaoFinanceiraService.deletarValoresDebitados(valor.id).then(() => {
                    this.form.splice(this.form.indexOf(valor), 1);
                    this.alertaSucesso('Valor removido com sucesso!');
                }).catch(() => {
                    this.alertaErro("Erro ao remover valor");
                })
            })
        },
    },
}
</script>
<style>
</style>